import { AppError } from "../../../shared/utils/error-handler";
import type { DepartmentRepository } from "../../repositories/company/department-repository";
import type { Department } from "../../types/department";
import type { UserInfoResponse } from "../../../shared/types/api";

export class DepartmentUseCase {
  constructor(private repository: DepartmentRepository) {}

  async getDepartments(companyId: number): Promise<Department[]> {
    try {
      return await this.repository.getDepartments(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 목록을 불러오지 못했습니다.",
        "DEPARTMENT_LIST_FAILED",
        error,
      );
    }
  }

  async createDepartment(companyId: number, name: string): Promise<Department> {
    try {
      return await this.repository.createDepartment(companyId, name);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 생성에 실패했습니다.",
        "DEPARTMENT_CREATE_FAILED",
        error,
      );
    }
  }

  async updateDepartment(
    companyId: number,
    departmentId: number,
    name: string,
  ): Promise<Department> {
    try {
      return await this.repository.updateDepartment(companyId, departmentId, name);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 수정에 실패했습니다.",
        "DEPARTMENT_UPDATE_FAILED",
        error,
      );
    }
  }

  async reorderDepartments(
    companyId: number,
    departmentIds: number[],
  ): Promise<Department[]> {
    try {
      return await this.repository.reorderDepartments(companyId, departmentIds);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 순서 변경에 실패했습니다.",
        "DEPARTMENT_REORDER_FAILED",
        error,
      );
    }
  }

  async deleteDepartment(companyId: number, departmentId: number): Promise<void> {
    try {
      await this.repository.deleteDepartment(companyId, departmentId);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 삭제에 실패했습니다.",
        "DEPARTMENT_DELETE_FAILED",
        error,
      );
    }
  }

  async assignMembers(
    companyId: number,
    departmentId: number,
    userIds: number[],
  ): Promise<UserInfoResponse[]> {
    try {
      return await this.repository.assignMembers(companyId, departmentId, userIds);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 회원 배정에 실패했습니다.",
        "DEPARTMENT_ASSIGN_FAILED",
        error,
      );
    }
  }

  async removeMember(
    companyId: number,
    departmentId: number,
    userId: number,
  ): Promise<void> {
    try {
      await this.repository.removeMember(companyId, departmentId, userId);
    } catch (error) {
      throw new AppError(
        String(error) || "부서 회원 제거에 실패했습니다.",
        "DEPARTMENT_REMOVE_FAILED",
        error,
      );
    }
  }
}